
export default function PrivacyPolicy() {
    return (
        <iframe src="/privacyPolicy.html" title="iCare Privacy Policy" className="w-full h-screen" frameBorder={0} style={{height: '98vh', width: '100%'}} />
    )
      
}